<script>
  import { blocklist, text, richtext, image, url, video, exists } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section>
  <div class="container-fluid p-0" style="position: relative;">
    <div class="overlay"></div>
    <video class="video-background d-block" autoplay muted loop playsinline
           poster="{image(block, 'videoPoster', [1500, null])}">
      <source src="{video(block, 'background')}" type="video/mp4">
      <source src="{video(block, 'backgroundAlt')}" type="video/webm">
      Your browser doesn't support HTML video tag.
    </video>

    <div class="content-position">
        <h1 class="text-light w-100" data-aos="fade-up">{text(block, 'headline')}</h1>
        <h2 class="text-light" data-aos="fade-up" data-aos-delay="400">{text(block, 'subheadline')}</h2>
        <div data-aos="fade-up" data-aos-delay="600">
          <div class="text-center text-lg-start">
            {#if exists(block, 'button')}
            <a href="{url(block, 'button')}" class="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
              <span>{text(block, 'button')}</span>
              <i class="bi bi-arrow-right"></i>
            </a>
            {/if}
          </div>
        </div>
    </div>
  </div>
</section>

<style>
  .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(90deg, rgba(0,0,0,0.25) 20%, rgba(255,255,255,0) 50%);
  }
  
  .text-bg {
      padding: 0px 10px;
      background-color: rgba(250, 250, 250, .8);
  }

  .video-background {
      width: 100%;
      object-fit: cover;
      min-height: 300px;
  }

  .content-position {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      padding-left: 50px;
      left: 0px;
      z-index: 100;
  }

  /* `lg` applies to medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
      .content-position {
          padding: 0px;
          text-align: center;
      }
  }
</style>
